angular
	.module('empower.modules')
	.constant('commonConst', {
		ROWS_PER_PAGE: 10,
		DATE_FORMAT: 'DD/MM/YYYY',
		DATETIME_FORMAT: 'DD/MM/YYYY hh:mm a',
		CLAIM: 'Claim',
		POLICY: 'Policy',
		IGNORE_APIs: ["api/claims/getnsidocuments", "api/activity/getactivity","api/common/addauditusage","api/notification/get", "api/users/login"],
		ROWS_PER_PAGE_ITEMS: [10,20,25]
	});